module.exports = __webpack_public_path__ + "static/media/face.3901d5a8.png";